import { useTranslation } from 'react-i18next';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import AffiliateIcon from 'components/icons/AffiliateIcon';
import { IntegrationSettings } from 'models/Integrations';
import { PropertyMetadata } from 'models/Properties';
import { orderBy } from 'utils/arrayUtils';
import { typedEntries } from 'utils/funcs';
import {
  DYNAMIC_PRICING_TOOLS,
  DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER,
} from './PricingUpdates.constants';

interface PricingUpdatesDynamicToolProps {
  integrationSettings: IntegrationSettings[] | undefined;
  pricingMetadata: PropertyMetadata['pricingMetadata'] | undefined;
}

const PricingUpdatesDynamicTool = ({
  integrationSettings,
  pricingMetadata,
}: PricingUpdatesDynamicToolProps) => {
  const { t } = useTranslation();
  const enabledIntegrations = integrationSettings?.filter(
    (integration) => integration.isEnabled,
  );
  const enabledPricingTools = typedEntries(DYNAMIC_PRICING_TOOLS).filter(
    ([affiliateEnum]) =>
      enabledIntegrations?.find(
        (integration) => integration.affiliateEnum === affiliateEnum,
      ),
  );
  const sortedPricingTools = orderBy(enabledPricingTools, [
    {
      field: ([key]) => DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER.indexOf(key),
      order: 'asc',
    },
  ]);

  const [affiliate, dynamicPricingTool] = sortedPricingTools[0] ?? [];

  if (!dynamicPricingTool || !affiliate) {
    return null;
  }

  return (
    <div className="pricing-tool-updates" data-testid="pricing-tool-updates">
      <span>
        {t('pageCalendar.standalone.pricingUpdates.dynamicPricingOn')}{' '}
        <a
          className="pricing-tool-link"
          href={dynamicPricingTool.url}
          target="_blank"
          rel="noreferrer"
        >
          <AffiliateIcon
            affiliate={affiliate}
            data-testid={`icon-${affiliate}`}
          />
          {dynamicPricingTool.name}
        </a>
      </span>
      {pricingMetadata?.pricingToolMostRecentUpdateDate && (
        <DropdownButton
          bsStyle="default"
          id="pricing-tool-updates"
          title={t('pageCalendar.standalone.pricingUpdates.lastUpdateFrom', {
            value: dynamicPricingTool.name,
          })}
        >
          <MenuItem>
            <AffiliateIcon affiliate={affiliate} />
            {t('common.dateTimeLongWithoutWeekDay', {
              date: pricingMetadata.pricingToolMostRecentUpdateDate,
            })}
          </MenuItem>
        </DropdownButton>
      )}
    </div>
  );
};

export default PricingUpdatesDynamicTool;
